<div *ngIf="report">

  <div [style]="styles.header.page">
    <div [style]="styles.header.text">
      <b>{{ primaryStrength }}</b>
    </div>
    <div [style]="styles.header.line"></div>
  </div>

  <div [style]="styles.container_padding">

    <h2 [style]="styles.general_h2">
      <b>
        {{
        isFacilitator
        ? 'Your Primary Facilitator Style'
        : 'Primary Preferred Coaching Style from You – ' + (report.name || '...')
        }}
      </b>
    </h2>

    <p [style]="styles.paragraph">
      {{
      isFacilitator
      ? 'Your primary facilitator style is the'
      : 'Their primary preferred coaching style from you is the'
      }}
      <span [style]="styles.highlight">{{ report.primaryCoachingStyle || '...' }}</span>.
    </p>

    <p [style]="styles.paragraph" [innerHtml]="html"></p>

  </div>

</div>